import React,{useEffect,useState} from 'react'
import Navbar from '../Components/Navbar'
import Intro from '../Components/Intro'
import BrandCarousel from '../Components/BrandCarousel'
import BrandCarousel2 from '../Components/BrandCarousel2'
import TopGames from '../Components/TopGames'
import { useNavigate } from 'react-router-dom'
import { getGamesApi } from '../Services/Api'
import axios from 'axios';
import CategoryCarousel from '../Components/CategoryCarousel'
import { type } from '@testing-library/user-event/dist/type'
import { computeHeadingLevel } from '@testing-library/react'
import Footer from '../Components/Footer'
import MostPlayed from '../Components/MostPlayed'


const Home = () => {

  const [data,setData] = useState([]);

  const navigate = useNavigate();

  function getRandomGames(data, count = 3) {
    // Step 1: Extract all games into a single array
    const allGames = data.flatMap(obj => obj.game);
  
    // Step 2: Shuffle the array and pick 'count' random games
    const shuffled = allGames.sort(() => 0.5 - Math.random());
    
    // Step 3: Return the first 'count' games
    return shuffled.slice(0, count);
  }



  const getData = async()=>{
    try{
      const res = await axios.get(getGamesApi);
      console.log(res.data.response)
      // const dataArray = Object.values(res.data);

      setData(res.data.response)
    }
    catch(err){
      console.log(err);
      navigate('/error')
    }
  }

  useEffect(()=>{
    getData();
  },[])


  

  

  



  return (
    <div>
      <Navbar />
      <Intro/>
      <BrandCarousel/>
      
      {
        data.slice(0,2)?.map((item,idx)=>{
        return(
          <div key={idx}>
          <CategoryCarousel data={item.game} category ={item.category}/>
          </div>
        )
      }
        )
      }
      <TopGames data={getRandomGames(data)}/>
      {
        data.slice(2,4)?.map((item,idx)=>{
        return(
          <div key={idx}>
          <CategoryCarousel data={item.game} category ={item.category}/>
          </div>
        )
      }
        )
      }
      <MostPlayed/>

      {
        data.slice(4,data?.length-1)?.map((item,idx)=>{
        return(
          <div key={idx}>
          <CategoryCarousel data={item?.game} category ={item.category}/>
          </div>
        )
      }
        )
      }
      <BrandCarousel2/>
      <Footer/>
    </div>
  )
}

export default Home
